import React from "react";
import {
  ICalendarEvent,
  getAppointmentTypeColor,
  isPastOccurrence,
} from "./agendaCalendarUtils";
import RecurrenceIndicator from "./RecurrenceIndicator";
import { AppointmentTypeEnum } from "../../models/enum/AgendaApi/AppointmentTypeEnum";

interface AgendaEventCardProps {
  event: ICalendarEvent;
  onRecurrenceClick: (event: ICalendarEvent) => void;
   isAgendaView?: boolean;
}

const AgendaEventCard: React.FC<AgendaEventCardProps> = ({
  event,
  onRecurrenceClick,
  isAgendaView = false,
}) => {
  const { resource } = event;
  const bgColor = getAppointmentTypeColor(resource.appointmentTypeID);
  const isPastEvent = isPastOccurrence(event.start, event.end);
  const isRoute = resource.appointmentTypeID === AppointmentTypeEnum.Route;

  const occurrence =
    event.occurrenceID !== null
      ? resource.occurrences?.find(
          (o) => o.appointmentOccurrenceID === event.occurrenceID
        )
      : undefined;
  const isTodayCheckInCompleted = occurrence?.isCheckIn === true && (() => {
    const n = new Date();
    const today = new Date(n.getFullYear(), n.getMonth(), n.getDate());
    const eventDay = new Date(event.start.getFullYear(), event.start.getMonth(), event.start.getDate());
    return eventDay.getTime() === today.getTime();
  })();
  const displayHourIn  = occurrence?.assignHourIn  ?? resource.assignHourIn;
  const displayHourOut = occurrence?.assignHourOut ?? resource.assignHourOut;
  const displayPosCode = occurrence?.posCode       ?? resource.posCode;
  const displaySubRetailName = occurrence?.subRetailName ?? resource.subretailName;
  const displayPointOfSale =
    occurrence?.isException && occurrence.pointOfSale
      ? occurrence.pointOfSale
      : resource.pointOfSale;

  return (
    <div
      className={`agendaEventCard${(isPastEvent || isTodayCheckInCompleted) ? " agendaEventCardPast" : ""}${(isPastEvent || isTodayCheckInCompleted) && isRoute ? " agendaEventCardPastRoute" : ""}`}
      style={{ backgroundColor: bgColor }}
      onClick={isAgendaView ? undefined : () => onRecurrenceClick(event)}
    >
      <div className="agendaEventHeader">
        <span className="agendaEventPos">{displayPointOfSale}</span>

        <div className="agendaEventActions">
          <RecurrenceIndicator
            appointmentTypeID={resource.appointmentTypeID}
            onClick={
              isAgendaView
                ? undefined
                : (e) => {
                    e.stopPropagation();
                    onRecurrenceClick(event);
                  }
            }
          />

          {isAgendaView && (
            <button
              type="button"
              className="agendaCardMenuBtn"
              onClick={(e) => {
                e.stopPropagation();
                onRecurrenceClick(event);
              }}
              aria-label="More actions"
              title="More actions"
            >
              ⋮
            </button>
          )}
        </div>
      </div>

      <div className="agendaEventBody">
        <span className="agendaEventDetail">{displayPosCode}</span>
        <span className="agendaEventDetail">{displaySubRetailName}</span>
        <span className="agendaEventDetail">
          {displayHourIn} - {displayHourOut}
        </span>
        <span className="agendaEventDetail">{resource.appointmentType}</span>
      </div>
    </div>
  );
};

export default AgendaEventCard;
